import ResendEmail from './ResendEmail';

export default ResendEmail;
